import { useNavigate } from "@solidjs/router";

/**
 * 招商银行
 * @param props
 * @returns
 */
export const zsRoot = (props: any) => {
  let navigate = useNavigate();
  function menuChange(e: any) {}

  //   const [menuState, setMenuState] = createSignal(0);

  //   useBeforeLeave((e: BeforeLeaveEventArgs) => {
  //     //"beforeLeave", e);
  //     // if (form.isDirty && !e.defaultPrevented) {
  //     //   // preventDefault to block immediately and prompt user async
  //     //   e.preventDefault();
  //     //   setTimeout(() => {
  //     //     if (window.confirm("Discard unsaved changes - are you sure?")) {
  //     //       // user wants to proceed anyway so retry with force=true
  //     //       e.retry(true);
  //     //     }
  //     //   }, 100);
  //     // }
  //   });

  return (
    <>
      <div>{props.children}</div>

    </>
  );
};
